import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data);
        // New Google volunteers haven't picked their interests yet — route them
        // through /welcome before the main dashboard. Returning volunteers go
        // straight to their dashboard.
        const dest = (!data?.interests || data.interests.length === 0) && data?.role !== "admin"
          ? "/welcome"
          : "/dashboard";
        window.history.replaceState(null, "", dest);
        nav(dest, { replace: true });
      } catch (e) {
        nav("/login?error=google", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--cream)]">
      <div className="text-center">
        <div className="mx-auto h-12 w-12 rounded-full bg-[color:var(--yellow)] animate-pulse" />
        <p className="mt-4 text-sm text-[color:var(--stone)]">Signing you in…</p>
      </div>
    </div>
  );
}
